"use client";

import { c as _c } from "react/compiler-runtime";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { IconChevronDown } from "@tabler/icons-react";
import type * as React from "react";
import { cn } from "@/lib/utils";
function Accordion(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <AccordionPrimitive.Root data-slot="accordion" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function AccordionItem(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("border-b", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AccordionPrimitive.Item data-slot="accordion-item" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function AccordionTrigger(t0) {
  const $ = _c(17);
  let Heading;
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      headingLevel: Heading,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Heading;
    $[2] = children;
    $[3] = className;
    $[4] = props;
  } else {
    Heading = $[1];
    children = $[2];
    className = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconChevronDown className="text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== t1) {
    t3 = <AccordionPrimitive.Trigger data-slot="accordion-trigger" className={t1} {...props}>{children}{t2}</AccordionPrimitive.Trigger>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const trigger = t3;
  if (Heading) {
    let t4;
    if ($[12] !== Heading || $[13] !== trigger) {
      t4 = <AccordionPrimitive.Header asChild={true}><Heading className="flex">{trigger}</Heading></AccordionPrimitive.Header>;
      $[12] = Heading;
      $[13] = trigger;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    return t4;
  }
  let t4;
  if ($[15] !== trigger) {
    t4 = <AccordionPrimitive.Header className="flex">{trigger}</AccordionPrimitive.Header>;
    $[15] = trigger;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function AccordionContent(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("pt-0 pb-4", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t2) {
    t3 = <AccordionPrimitive.Content data-slot="accordion-content" className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm" {...props}>{t2}</AccordionPrimitive.Content>;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };